import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const BoldIcon = createSvgIcon(
  <>
    <path d="M9.02336 6.79C10.0411 6.12 10.7546 5.02 10.7546 4C10.7546 1.74 8.91844 0 6.55768 0H0V14H7.38657C9.57945 14 11.2792 12.3 11.2792 10.21C11.2792 8.69 10.3769 7.39 9.02336 6.79V6.79ZM3.14768 2.5H6.29537C7.16623 2.5 7.86921 3.17 7.86921 4C7.86921 4.83 7.16623 5.5 6.29537 5.5H3.14768V2.5ZM6.81998 11.5H3.14768V8.5H6.81998C7.69084 8.5 8.39383 9.17 8.39383 10C8.39383 10.83 7.69084 11.5 6.81998 11.5Z" />
  </>,
  "BoldIcon"
);

export default BoldIcon;
